module.exports = __webpack_public_path__ + "static/img/A67.dbab92fe.jpg";